import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from 'vue';
import useViewer from '@/composables/global/use-viewer';
export default /*#__PURE__*/_defineComponent({
  __name: 'TheShellHeaderCallIndicator',
  setup(__props) {
    _useCssVars(_ctx => ({
      "b830e1dc": indicatorBottom.value
    }));
    const {
      isOnIos
    } = useViewer();
    const indicatorBottom = computed(() => isOnIos.value ? '17px' : '22px');
    return (_ctx, _cache) => {
      const _component_ion_icon = _resolveComponent("ion-icon");
      return _openBlock(), _createBlock(_component_ion_icon, {
        name: "ellipse",
        color: "danger",
        class: "unviewed-badge",
        slot: "icon-only"
      });
    };
  }
});